import { useLocation } from 'react-router-dom';

import { useQuery } from '@apollo/client';

import { sentryService } from '../services';

export const useGraphqlQuery = (
  isPreview: boolean,
  sysId: string,
  queryMethod: any,
  isMenuType: boolean = false,
  menuType: string = '',
  contentModelName: string = '',
  componentName: string = ''
) => {
  const { pathname } = useLocation();
  const queryOptions: any = {
    variables: {
      usePreview: isPreview,
      id: sysId,
    },
  };

  const queryMenuOptions: any = {
    variables: {
      usePreview: isPreview,
      menuType: menuType,
    },
  };

  /*if (isPreview) {
    if (isPreview) {
      queryOptions.pollInterval = 2000;
      queryOptions.fetchPolicy = 'network-only';
    }
  }*/

  if (contentModelName !== '') {
    queryOptions.variables.contentModalName = contentModelName;
  }

  const { data, error, loading, refetch } = useQuery(queryMethod, {
    ...(isMenuType ? queryMenuOptions : queryOptions),
    skip: isMenuType ? false : contentModelName === '' && !sysId, // ✅ Apollo will skip the query if true
  });

  if (error && sentryService.isSentryServiceEnabled()) {
    let customErr = { ...error, sysId };
    let path = pathname.split('/')[1];
    let endpoint = isMenuType ? menuType : componentName + ' - ' + (path !== '' ? path : 'home');
    sentryService.captureAPIErrors(customErr, 'Graphql', endpoint);
  }

  return {
    data,
    loading,
    error,
    refetch,
  };
};
